import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ResearchMain from './ResearchMain';

const ResearchPage = () => {
    return (
        <div className="research-page">
            <Header />
            <div className="research-page__content">
                <ResearchMain />
            </div>
            <Footer />
        </div>
    );
}

export default ResearchPage;
